import ContentLoader from 'react-content-loader';

const PastTripCardPlaceholder = (): JSX.Element => {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={130}
      backgroundColor="#D4D9DB"
      foregroundColor="#EFF2F5"
      uniqueKey="UpcomingTrip-123"
    >
      <rect x="0" y="0" height="130" width="130" />
      <rect x="146" rx="4" ry="3" y="20" height="16" width="180" />
      <rect x="146" rx="4" ry="3" y="52" height="16" width="140" />
      <rect x="146" rx="4" ry="3" y="78" height="16" width="30" />
      <rect x="188" rx="4" ry="3" y="78" height="16" width="30" />
    </ContentLoader>
  );
};

export default PastTripCardPlaceholder;
